import React, { useEffect, useState } from 'react';
import { getPageContent } from '../../../services/page.service';
import theme, { roboto } from '../../../theme';
import { CookieConsent } from 'react-cookie-consent';

/**
 *
 * @constructor
 */
export function CookieUi(): JSX.Element {
    const [textCookie, setTextCookie] = useState<string>();
    useEffect(() => {
        let isMounted = true;

        //Récupération du texte du cookie
        getPageContent('cookies')
            .then(result => {
                const value = result?.find(entry => entry.codeChamps === 'content')?.valeur;
                if (value) {
                    isMounted && setTextCookie(value);
                }
            })
            .catch(() => {
                console.error('Erreur lors de la récupération du texte des coookies');
            });

        //unamount
        return () => {
            isMounted = false;
        };
        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //On renvoi la bandeaux de gestion cooki que si nous avons le texte
    if (textCookie) {
        return (
            <CookieConsent
                location="bottom"
                buttonText="J'accepte"
                declineButtonText="Je refuse"
                cookieName="acceptGoogle"
                overlay={true}
                style={{ background: theme.palette.blue.main }}
                buttonStyle={{ background: theme.palette.green.main, fontSize: '13px', borderRadius: '3px' }}
                declineButtonStyle={{ borderRadius: '3px' }}
                expires={1}
                enableDeclineButton
            >
                <div style={{ fontFamily: roboto }} dangerouslySetInnerHTML={{ __html: textCookie }}></div>
            </CookieConsent>
        );
    }
    return <></>;
}
